import { z } from 'zod';

export const DimensionsSchema = z.object({
  width: z.number().nullable().default(null),
  height: z.number().nullable().default(null),
  numTiles: z.number().nullable().default(null),
  tileSize: z.number().nullable().default(null),
  pixelPerMillimeter: z.number().nullable().optional(),
  depth: z.string().nullable().optional(),
  maxZoom: z.number().nullable().optional(),
})

export type Dimensions = z.infer<typeof DimensionsSchema>;